
const DEFAULT_CUTOFF = '2026-08-23T23:59:59+05:00';

export const KURULTAI_BANNER_CUTOFF = DEFAULT_CUTOFF;

export function isKurultaiBannerActive(now = Date.now()) {
  let cutoff = new Date(KURULTAI_BANNER_CUTOFF).getTime();
  if (isNaN(cutoff)) {
    cutoff = new Date(DEFAULT_CUTOFF).getTime();
  }
  return now <= cutoff;
}
